<ion-item>
  <ion-label>{{ field.label }}</ion-label>
</ion-item>

<ng-container *ngIf="cFormArray">
  <ng-container *ngFor="let group of cFormArray.controls">
    <ng-container *ngIf="group | asFormGroupPipe as formGroup">
      <ng-container *ngIf="formGroup.controls['label'] | asFormControlPipe as formControl">
        <ion-row class="ion-align-items-center">
          <ion-col size="auto" *ngIf="!disabledField">
            <ion-button (click)="onRemoveFormGroupClick(formGroup)" color="danger" size="small" fill="clear">
              <ion-icon slot="icon-only" name="trash-outline" shape="round"></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-item [disabled]="disabledField" [ngClass]="{'gl-disable-invisible': disabledField}">
              <ion-input class="gl-input-highlight" [formControl]="formControl" [type]="'text'"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="auto">
            <ion-toggle color="success" class="gl-style-label" disabled="true"></ion-toggle>
          </ion-col>
        </ion-row>
    </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ion-row *ngIf="!disabledField">
  <ion-button (click)="onAddNewFormGroupClick()" size="small">
    <ion-icon slot="icon-only" name="add"></ion-icon>
  </ion-button>
</ion-row>
